import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 3a1 1 0 011 1v3a1 1 0 11-2 0V4a1 1 0 011-1zm3 3a1 1 0 112 0v1a1 1 0 11-2 0V6zM7 5a1 1 0 00-1 1v1a1 1 0 002 0V6a1 1 0 00-1-1zm-3 6a2 2 0 012-2h10a2 2 0 012 2h1c.493 0 1.211.14 1.834.588C21.51 12.075 22 12.874 22 14s-.491 1.926-1.166 2.412A3.233 3.233 0 0119 17h-1.84c-.473.803-1.09 1.47-1.699 2H18a1 1 0 110 2H5a1 1 0 110-2h1.539C5.288 17.91 4 16.246 4 14v-3zm13.913 4H19c.173 0 .456-.06.666-.211.159-.115.334-.315.334-.789 0-.474-.175-.674-.334-.789A1.239 1.239 0 0019 13h-1v1c0 .347-.03.68-.087 1zm-6.114 3.997l-.007.003h-1.584l-.007-.003a10.285 10.285 0 01-2.076-1.278C6.97 16.795 6 15.552 6 14v-3h10v3c0 1.552-.97 2.795-2.125 3.72a10.288 10.288 0 01-2.076 1.277z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
